import { render, staticRenderFns } from "./AttendanceDashboard.vue?vue&type=template&id=b6c1d108&"
import script from "./AttendanceDashboard.vue?vue&type=script&lang=js&"
export * from "./AttendanceDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports